import { pxToRem, scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const ColumnContainer = styled.div `
  display: flex;
  width: 100%;
  position: relative;
  overflow: hidden;
`;
export const InputColumn = styled.div `
  display: flex;
  width: 30%;
  flex-direction: column;
  overflow: auto;
  ${scrollbar({ trackMargin: 'xl' })};
  padding: ${theme.spacing['2xl']};
  border-right: ${pxToRem(1)} solid ${theme.semantic.border.default};
`;
export const PreviewColumn = styled.div `
  display: flex;
  width: 70%;
  flex-direction: column;
  overflow: auto;
  ${scrollbar({ trackMargin: 'xl' })};
  padding: ${theme.spacing['2xl']};
  padding-bottom: 0;
`;
export const PreviewFooter = styled.div `
  display: flex;
  gap: ${theme.spacing.lg};
  position: sticky;
  bottom: 0;
  width: 100%;
  background: linear-gradient(0, ${theme.semantic.surface.primary} 50%, transparent);
  justify-content: flex-end;
  padding-top: ${theme.spacing.xl};
  padding-bottom: ${theme.spacing['2xl']};
`;
export const VisualizationContainer = styled.div `
  border: ${pxToRem(1)} solid ${theme.semantic.border.default};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing['2xl']};
  height: ${pxToRem(400)};
  align-content: center;
  overflow-x: auto;
  ${scrollbar({ trackMargin: 'xl' })};
`;
export const FieldInputContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${theme.spacing.lg};
`;
